export const simplifyString = (str: string) => {
    return str.replace(/(.)\1{5,}(?=\1)/g, '$1 .. ');
};